// extracted by mini-css-extract-plugin
export default {"form":"JsonForm_form__NzEdb"};